var exports = {
  "i": "x234b8571--661030--wrapper",
};

module.exports = exports;
